const CHILE_OFFER_FLOW_STEP_IDS = {
  SELECT_INVOICES: 'select-invoices-step',
  SELECT_DATES: 'select-dates-step',
  CESSION: 'cession-step',
  FINISH_CESSION: 'finish-cession-step',
  // Compartidos: tutorial y carrito
  CREDENTIAL_PROVIDER_SELECTOR: 'credential-provider-selector-step',
  CESSION_TYPE_SELECTOR: 'cession-type-selector-step',
  // Carrito — pasos internos
  SUMMARY: 'summary-step',
  CREDENTIAL_PROVIDER_CREDENTIALS: 'credential-provider-credentials-step',
  UPLOAD_DOCUMENTS: 'upload-documents-step',
  UPLOAD_CERTIFICATE: 'upload-certificate-step',
  SELECT_BANK_ACCOUNT: 'select-bank-account-step',
  EXTERNAL_CESSION_INSTRUCTIONS: 'external-cession-instructions-step',
  EXTERNAL_CESSION_BANK_ACCOUNT: 'external-cession-bank-account-step',
  OPERATION_CONFIRMATION: 'operation-confirmation-step',
};

export default CHILE_OFFER_FLOW_STEP_IDS;
